import { render, staticRenderFns } from "./SpotBottomLine.vue?vue&type=template&id=1243f8e8&scoped=true&"
import script from "./SpotBottomLine.vue?vue&type=script&lang=js&"
export * from "./SpotBottomLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243f8e8",
  null
  
)

export default component.exports